import axios from "axios";
import { SatelliteTleData } from "./types";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:8787";

export const fetchTleData = async (): Promise<SatelliteTleData[]> => {
  const response = await axios.get(
    `${baseURL}/fetchTleData?k=${process.env.REACT_APP_API_KEY}`
  );

  if (Array.isArray(response.data)) {
    return response.data;
  } else if (response.data) {
    return [response.data];
  }

  return [];
};
